<template>
	<div class="d-flex">
    <div class="d-flex align-center cursor-pointer" @click="snackbarFun">
      <v-badge
        bordered
        color="red"
        dot
        :value="$store.state.approval.approvalNotice"
      >
        <v-icon size="22">{{ icons.mdiBellOutline  }}</v-icon>
      </v-badge>
    </div>
		<div class="text ms-4" :style="{'right': $vuetify.breakpoint.mdAndDown ? '0px' : '45px'}">
			<v-menu offset-y open-on-hover>
				<template v-slot:activator="{ on, attrs }">
					<div v-bind="attrs" v-on="on">
						<img class="img-url" v-if="photoData" :src="photoData" alt=""></img>
						<img class="img-url" v-else src="@/assets/img/head.png" alt=""></img>
						<span class="user" :class="$vuetify.breakpoint.mdAndDown ? 'user-s': ''" :style="{color: $vuetify.theme.dark ? '#fff':'#333'}">{{username}}</span>
					</div>
				</template>

				<v-list>
					<v-list-item @click="languagesChange">
						<v-list-item-title class="d-flex align-center">
							<v-icon size="18">{{ icons.mdiWeb }}</v-icon>
							<span class="menu-text">{{languages}}</span>
						</v-list-item-title>
					</v-list-item>
					<v-list-item @click="goOut">
						<v-list-item-title class="d-flex align-center">
							<v-icon size="18">{{ icons.mdiLogoutVariant }}</v-icon>
							<span class="menu-text">{{$t('header.goOut')}}</span>
						</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</div>

        <!-- 会话状态提示框 -->
    	<del-dialog
            class="modal-box"
            :dialogDelete="dialogueVisible"
            :dialogTitle="$t('header.modalTitle')"
            :okText="$t('header.okText')"
            :cancelText="$t('header.goOut')"
            :persistent="true"
            @deleteItemConfirm="handleOk"
            @close="handleCancel">
            <div slot="dialogContent" class="pa-5 time-value">
                {{timeValue}}
            </div>
        </del-dialog>

        <!-- 通知弹框 -->
        <v-snackbar
            v-model="showSnackbar"
            class="snackbar-box"
            bottom
            right>
            <div class="cursor-pointer" @click="snackbarFun">{{ snackbarContent }}</div>
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="pink"
                    text
                    v-bind="attrs"
                    style="font-size:14px;"
                    @click="showSnackbar = false"
                    >
                    {{$t('btn.closeBtn')}}
                </v-btn>
            </template>
        </v-snackbar>
	</div>
</template>


<script>
import {
  mdiLogoutVariant,
  mdiWeb,
  mdiBellOutline
} from '@mdi/js'
import { logout, userPhoto, getLoginApp, noPullList, refreshSession ,reqGetWaterConf,reqGetToDoViewCount} from "@/api/index";
import {IsIPMode,setPersistenceCookie,setUserExpriationTip,clearCookie} from '@/utils/cookie'
import {setNavigationInfo,sendCorsRequest} from '@/utils/serverUrl'
import store from '@/store'
import moment from 'moment';
import {watermark,removeWatermark} from "@/utils/watermark";
import * as workerTimers from 'worker-timers';
import { delCookie } from '../../../../utils/cookie'

export default {
    data() {
        return {
            username: '',
            photoData: '',
            workerTimeId: null,
            dialogueVisible: false,
            timeInterNot:null,
            timeValue: null,
            languages: this.$t('login.zhCN'),
            icons: {
              mdiLogoutVariant,
              mdiWeb,
              mdiBellOutline
            },
            snackbarContent: "",
            showSnackbar: false,
            watermarkContentConf:null,
            waterMarkColor:"",
            showBadge:false,
        };
    },
    created() {
        this.username = this.$cookieStore.getCookie("userInfo").username

        this.$root.eventHub.$on('usernameChange', (item)=> {
            this.username = item
        })
        this.$root.eventHub.$on('headImgChange', (item)=> {
            this.photoData = item
        })
         // 获取个人头像
        this.getUserPhoto()
        // 获取企业logo
        this.getappLogo()

        // 通知弹框
        this.openNotification()
        let num = parseInt(this.$cookieStore.getCookie("noticePullInterval"))
        if (typeof num == "number" && !isNaN(num)) {
              this.timeInterNot = setInterval(()=>{
                if(!this.$cookieStore.getCookie("userInfo")) {
                    clearInterval(this.timeInterNot)
                } else {
                    this.openNotification()
                }
            }, num)
        }

        this.languages = this.$cookieStore.getCookie('lang') == "en" ? "Chinese" : "英文"
        // this.timer = setInterval(()=>{
        //     // 获取在线状态时间

        this.timer = setInterval(()=>{
            // 获取在线状态时间

        },1000)

        // 判断当前手机浏览器是360浏览器
        this.is360Phone()
    },
    mounted(){
        this.workerTimeId = workerTimers.setInterval(this.periodicWork, 1000);
        window.addEventListener('resize',this.resizeDrawWater)

        // this.getToDoCount()



    },
  watch:{
      $route(to,from){
         if(!to.path.includes('/login') && !from.path.includes('/login')){
           // location.reload();
         }
      }
  },
  beforeDestroy () {
    this.$root.eventHub.$off('headImgChange')
    window.removeEventListener('resize', this.resizeDrawWater)
    if(this.workerTimeId){
      workerTimers.clearInterval( this.workerTimeId);
    }
  },
  methods: {
        moment,
        periodicWork(){
            // 用户本地过期时间
            let expNum = parseInt(this.$cookieStore.getCookie("userLocalExpiration"))
            let remindTime = parseInt(this.$cookieStore.getCookie("outRemindTime"))
            if(!remindTime) {
                //会话默认5分钟
                remindTime = 300
            }
            // 判断是否登录状态
            if(!this.$cookieStore.getCookie("userInfo")) {
                workerTimers.clearInterval( this.workerTimeId);
                this.workerTimeId = null
                this.goOut() //倒计时结束，退出登录
            }
            let currentTimeUnix = moment().unix()
            let surplusTime = expNum - currentTimeUnix
            if (typeof expNum == "number" && !isNaN(expNum) && expNum != undefined) {
              //会话时间小于2秒退出
              if(surplusTime < 1) {
                workerTimers.clearInterval(this.workerTimeId);
                this.workerTimeId = null
                this.goOut() //倒计时结束，退出登录
              }else{

                if(surplusTime  <= remindTime) {
                  this.timeValue = moment.unix(surplusTime).format("00:mm:ss")
                  this.dialogueVisible = true
                }else{
                   this.dialogueVisible = false
                }
              }
            }
        },
        openNotification() {
            noPullList().then(res=> {
                // res = {"code":200,"message":"ok","data":[{"id":695606,"title":"22222","content":"这是一段测试的文本","state":0,"stateStr":"未读","readTime":0,"managerName":"123qwe","publishTime":1666086360}]}
                if (res.code == 200 && res.data.length > 0) {
                    this.snackbarContent = this.$t('header.tip1') + res.data.length + this.$t('header.tip2')
                    this.showSnackbar = true
                    store.commit('approval/SET_APPROVAL_STATE',true)
                }
            })
            // const h = this.$createElement
            // noPullList().then(res=> {
            //     if (res.code == 200 && res.data.length > 0) {
            //         this.$notification.open({
            //             message: this.$t('header.notification'),
            //             description: h('div', null, [
            //                 h('p', null, [
            //                     h(
            //                     'a',
            //                     {
            //                         on: {
            //                             click: () => {
            //                                 this.$notification.close("1")
            //                                 if(window.location.hash.indexOf("#/inform") > -1) {
            //                                     this.$root.eventHub.$emit('reloadInformList')
            //                                 }else {
            //                                     this.$router.push("/inform")
            //                                 }

            //                             }
            //                         }
            //                     },
            //                     `${this.$t('header.tip1')}${res.data.length}${this.$t('header.tip2')}`
            //                     )
            //                 ]),
            //             ]),
            //             key: "1",
            //             duration: 10,
            //             placement: "bottomRight",
            //             style: {
            //                 width: '300px',
            //                 marginLeft: `${80}px`,
            //             },
            //         });
            //     }
            // })
        },
        snackbarFun() {
            if(window.location.hash.indexOf("#/inform") > -1) {
                this.showSnackbar = false
                this.$root.eventHub.$emit('reloadInformList')
		            store.commit('approval/SET_APPROVAL_STATE',false)
            } else {
                this.showSnackbar = false
                this.$router.push("/inform")
		            store.commit('approval/SET_APPROVAL_STATE',false)
            }
        },
        getappLogo() {
            let params = {
                appDomainName: window.location.href
            }
            getLoginApp(params).then(res=> {
              if(res.code == 200) {
                  this.drawPageWater(res.data)
                  setNavigationInfo(res.data)
                  let listData = this.$cookieStore.getCookie("userInfo")
                  listData.username = res.data.username
                  setPersistenceCookie('userInfo', listData)
                  this.username =  res.data.username
                  if(res.data.companyLogoBase64) {
                    // console.log(res.data.companyLogoBase64)
                     store.commit('app/SET_COMPANY_LOGO',res.data.companyLogoBase64)
                  }
              }
            })
        },
        getUserPhoto() {
            userPhoto().then(res=>{
                if (res.code == this.$GLOBA.StatusOK) {
                    this.photoData = res.data ? 'data:image/png;base64,'+res.data : require('@/assets/img/head.png')
                }
            })
        },
        goOut() {
            logout().then(res=>{
                if (res.code == this.$GLOBA.StatusOK) {

                    if(this.workerTimeId) {
                      workerTimers.clearInterval( this.workerTimeId);
                      this.workerTimeId= null
                    }
                    clearInterval(this.timeInterNot)
                    store.dispatch('snackbar/openSnackbar',{
                      snackbarText: res.message,
                      colorType: 'success'
                    })
                    let lang = this.$cookieStore.getCookie('lang') ?this.$cookieStore.getCookie('lang') : 'zh'

                    let locationHref = '/login/'
                    if(IsIPMode()) {
                        locationHref = locationHref +'?appKey='+this.$route.query.appKey
                     }
                    clearCookie(["userInfo","outRemindTime","userEditPwd","noticePullInterval","userLocalCycleTime","userLocalExpiration",'zeroTrust'])
                    localStorage.removeItem('rsaKey')
                    localStorage.removeItem('environment')
                    localStorage.removeItem('urlMode')
                    this.$cookieStore.setCookie('lang', lang,866400*365)
                    this.$i18n.locale = lang
                    this.$router.push(locationHref)
                    // localStorage.clear()
                }
            })
        },
        handleOk() {
            refreshSession().then(res=> {
                if(res.code == 200) {
                    this.dialogueVisible = false
                    setUserExpriationTip(res.data.sessionEffectivelyTime)
                }
            })
        },
        handleCancel(key) {
            if(key != "modelClose") {
                clearInterval(this.timer)
                this.goOut()
            }
        },
        languagesChange() {
            if( this.$cookieStore.getCookie('lang') == "zh") {
                this.$i18n.locale = 'en'
                this.$cookieStore.setCookie('lang', 'en',86400*365)
                this.$cookieStore.setCookie('Accept-Language-User', "en-US",10*365*24*60*60)
            } else {
                this.$i18n.locale = 'zh'
                this.$cookieStore.setCookie('lang', 'zh',86400*365)
                this.$cookieStore.setCookie('Accept-Language-User',"zh-CN",10*365*24*60*60)
            }
            this.languages = this.$cookieStore.getCookie('lang') == "en" ? "Chinese" : "英文"
            // 暴露更新语言接口
            this.$root.eventHub.$emit('languagesChange')
            location.reload();
        },
        /**
     * 0-自定义文字
     1-用户名
     2-企业名称_用户名
     3-用户名_ip
     4-企业名称_用户名_ip
     * */
    //绘制用户水印
    drawPageWater(userData){
      reqGetWaterConf().then(res=>{
        if(res.code == 200) {
          removeWatermark();
          if(res.data && res.data.disable == 1 && res.data.scope != 2) {
            let text = ''
            switch (res.data.watermarkFlag) {
              case 0:
                text = res.data.watermarkContent
                break;
              case 1:
                text = userData.username
                break;
              case 2:
                text = userData.companyName + '_' + userData.username
                break;
              case 3:
                text = userData.username +'_'+ res.data.watermarkContent
                break;
              case 4:
                text = userData.companyName + '_' + userData.username +'_'+ res.data.watermarkContent
                break;
              default:
                break;
            }
            //开启水印
            console.log("res.data.color",res.data.color)
            this.waterMarkColor = res.data.color
            let setObject = {
              watermark_txt:text,
              // watermark_color:res.data.color,
              watermark_color:this.is360Phone ? this.colorChange(this.waterMarkColor) : res.data.color,
              watermark_fontsize:res.data.workSize,
              watermark_font:res.data.fontFamily,
              watermark_angle:res.data.plateType,
            }
            this.watermarkContentConf = setObject
            watermark.set(setObject)
          }else{
            this.watermarkContentConf = null
          }
        }else{
          this.watermarkContentConf = null
        }
      })
    },
    is360Phone(){
      // 判断当前手机浏览器是否为360浏览器
      // var UA = navigator.userAgent;
      // console.log(UA.toLowerCase())
      // let is360se = UA.toLowerCase().indexOf('360se')>-1 ? true : false;
      // return is360se


        // 当前设备是移动设备
        if (/Android|iPhone|iPad|iPod/i.test(navigator.platform)) {
        //application/vnd.chromium.remoting-viewer 可能为360特有
          var is360 = this.mime("type", "application/vnd.chromium.remoting-viewer");
          if(this.isChrome() && is360) {
              console.log("检测到是360浏览器");
              return true
          }else{
            console.log("检测到bububu是360浏览器");
            return false
          }
        }
    },
    //检测是否是谷歌内核(可排除360及谷歌以外的浏览器)
    isChrome(){
        var ua = navigator.userAgent.toLowerCase()
        return ua.indexOf("chrome") > 1
    },
    //测试mime
    mime(option, value) {
        var mimeTypes = navigator.mimeTypes;
        console.log("mimeTypes",mimeTypes)
        for (var mt in mimeTypes) {
            if (mimeTypes[mt][option] == value) {
                return true;
            }
        }
        return false;
    },
    // 十六进制颜色值转换rgb形式
    hexToRgba(hex, opacity) {
        let rgba = 'rgba(' + parseInt('0x' + hex.slice(1,3)) + ',' +
            parseInt('0x' + hex.slice(3,5)) + ',' +
            parseInt('0x' + hex.slice(5,7)) + ',' +
            (opacity || "1") + ')'
        return rgba
    },
    // 十六进制透明度转换rgba形式
    colorChange(value){
      if(value.length == 9){
          let opacityVal = value.slice(7,9)
          let decimal = Number.parseInt(opacityVal, 16);
          let opacity = Math.round((decimal / 255)*100)/100
          let sixColor = this.hexToRgba(value,opacity)
          return sixColor
      }else{
          return value
      }
    },
    resizeDrawWater(){
      if(this.watermarkContentConf) {
        removeWatermark();
        watermark.set(this.watermarkContentConf)
      }
    },
    getToDoCount(){
      reqGetToDoViewCount().then(res=>{
        if(res.code == 200){
          if(res.data > 0) {
            store.commit('toDo/SET_TODO_COUNT_STATE',true)
          }else{
            store.commit('toDo/SET_TODO_COUNT_STATE',false)
          }
        }

      })

    }

  },
}
</script>

<style lang='scss' scoped>
// .header {
//     width: 100%;
//     height: 70px;
//     background: #fafafa;
//     box-shadow: 0px 0px 23px 1px rgba(0, 0, 0, 0.07);
//     z-index: 2;
//     position: relative;
    .logo-box {
        position: absolute;
        top: 50%;
        left: 55px;
        transform: translateY(-50%);
        img {
            height: 50px;
        }
    }
    .text {
        // position: absolute;
        right: 45px;
        top: 50%;
        // transform: translateY(-50%);
        cursor: pointer;
        display: flex;
        align-items: center;
        .user {
            margin-left: 15px;
            font-size: 16px;
            font-weight: 500;
            vertical-align: middle;
        }
        .user-s {
            max-width: 100px;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .img-url {
		width: 40px;
		height: 40px;
        border-radius: 50%;
    }
// }
.statistic-box {
    text-align: center;
}
.modal-box ::v-deep {
  .ant-modal-footer {
    overflow: auto;
  }
  .ant-btn:first-child {
    float: right;
    margin-left: 8px;
  }
}
.overlay-box ::v-deep {
    padding: 10px 0;
    .ant-dropdown-menu-item {
        padding: 8px 25px;
    }
    .overlay-icon {
        margin-right: 6px;
    }
}
.menu-text {
	font-size: 14px;
	margin-left: 3px;
}
.time-value {
    font-size: 18px;
    text-align: center;
    margin-bottom: 15px;
}
::v-deep .v-badge--dot .v-badge__badge{
    height: 8px !important;
    width: 8px !important;
    background: red;
}
</style>
